export default __webpack_public_path__ + "static/media/IMG_9996.014e0e81.jpg";